import Swiper from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

export default class Gallery {
    constructor() {
        document.querySelectorAll('.js-gallery').forEach((root) => {
            const el = root.querySelector('.js-gallery__swiper');

            if (!el) return;

            new Swiper(el, {
                a11y: true,
                autoHeight: false,
                modules: [A11y, Navigation],
                navigation: {
                    nextEl: root.querySelector('.js-gallery__nav.is-next'),
                    prevEl: root.querySelector('.js-gallery__nav.is-prev'),
                    disabledClass: 'is-disabled',
                },
                centeredSlides: false,
                slidesPerGroup: 1,
                slidesPerView: 1,
                spaceBetween: 0,
                breakpoints: {
                    1024: {
                        centeredSlides: true,
                        slidesPerView: 'auto',
                        spaceBetween: 40,
                    },
                },
            });
        });
    }
}
